import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";

export default function Static({ title, children }) {
  const loc = useLocation();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <Seo
        title={`${title} | ToolHaus`}
        description={`${title} for ToolHaus, the free online tool suite with no signup required.`}
        path={loc.pathname}
      />
      <Link to="/" className="text-sm text-primary hover:underline" data-testid="back-static">← Back</Link>
      <h1 className="font-heading text-4xl font-semibold mt-6 mb-6">{title}</h1>
      <div className="prose prose-gray max-w-none text-gray-700 leading-relaxed space-y-4">
        {children}
      </div>
    </div>
  );
}
